import React, {useEffect, useRef, useState} from 'react';
import {Loader} from '@googlemaps/js-api-loader';
import {
    InputTextField,
    Button,
} from '@cuatroochenta/co-admin-react-library';
import './GoogleMap.scss';

export interface Props {
    coordinates: {latitude: number, longitude: number, title?: string}[];
    handleChangePosition?: (latitude: number, longitude: number) => void,
    draggableCoordinates?: boolean,
    zoom?: number,
}

const GOOGLE_MAPS_API_KEY = 'AIzaSyDrIUY8ph-5VUadI6H_ibD9sM_Cpu4pWKY';

export const GoogleMap = (props: Props): React.ReactElement => {
    const mapContainerRef = useRef<HTMLDivElement | null>(null);
    const mapRef = useRef<google.maps.Map | null>(null);
    const markersRef = useRef<google.maps.Marker[]>([]);
    const [address, setAddress] = useState('');

    useEffect(() => {
        const loader = new Loader({
            apiKey: GOOGLE_MAPS_API_KEY,
            version: "weekly",
        });

        const mapOptions = {
            center: {
                lat: props.coordinates[0].latitude,
                lng: props.coordinates[0].longitude,
            },
            zoom: props.zoom ? props.zoom : 15,
        };

        loader
            .importLibrary('maps')
            .then(() => {
                if (!mapContainerRef.current || (mapRef.current && props.draggableCoordinates)
                ) {
                    return;
                }
                mapRef.current = new window.google.maps.Map(mapContainerRef.current, mapOptions);
                markersRef.current = getMarkers();
                if (markersRef && markersRef.current && props.draggableCoordinates) {
                    markersRef.current[0].addListener('dragend', (event: any) => {
                        const newLat = event.latLng.lat();
                        const newLng = event.latLng.lng();
                        if (markersRef.current) {
                            markersRef.current[0].setPosition({lat: newLat, lng: newLng});
                        }
                        props.handleChangePosition && props.handleChangePosition(newLat, newLng);
                    });
                }
                if (!props.draggableCoordinates) {
                    updateMarkers();
                }
            });
    }, [props.coordinates]);

    const clearMarkers = () => {
        markersRef.current.forEach((marker) => marker.setMap(null));
        markersRef.current = [];
    };

    const updateMarkers = () => {
        if (!mapRef.current) {
            return;
        }
        clearMarkers();
        markersRef.current = getMarkers();
    };

    const getMarkers = () => {
        return props.coordinates.map((coordinate) => {
            return new google.maps.Marker({
                position: {
                    lat: coordinate.latitude,
                    lng: coordinate.longitude,
                },
                map: mapRef.current,
                title: coordinate.title,
                draggable: props.draggableCoordinates,
            });
        });
    }

    const geocodeAddress = (address: string) => {
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({address: address}, (results: any, status: any) => {
            if (status === 'OK') {
                const newCoordinates = results[0].geometry.location;
                const newMarkerCoords = {
                    lat: newCoordinates.lat(),
                    lng: newCoordinates.lng(),
                };
                if (markersRef && markersRef.current) {
                    markersRef.current[0].setPosition(newCoordinates);
                    mapRef && mapRef.current && mapRef.current.panTo(newCoordinates);
                    mapRef && mapRef.current && mapRef.current.setZoom(15);
                    props.handleChangePosition && props.handleChangePosition(newMarkerCoords.lat, newMarkerCoords.lng);
                }
            }
        });
    };

    const handleSearch = () => {
        geocodeAddress(address);
    };

    return (
        <div className={"component-google-map"}>
            {props.draggableCoordinates &&
                <div className={"component-search"}>
                    <InputTextField
                        label={'Introduce una dirección'}
                        type={'text'}
                        value={address}
                        onChange={(value: string) => setAddress(value)}
                    />
                    <Button
                        content={'Buscar'}
                        onClick={handleSearch}
                    />
                </div>}
            <div
                ref={mapContainerRef}
                className={"component-map-container"}
            />
        </div>
    );
};